// author：jiana
// time:2024-06-12
// desc:本页面为方便快速构建vue文件模板基础页面搭建，在次基础上快速搭建

<template>
	<div class="menuNav">
		<div :class="!bgClass ? 'menuBox' : 'menuBoxOne'">
			<div class="menu">
				<el-row>
					<el-col :span="5">
						<img src="../../assets/imgs/logo.png" alt="" class="imgBox" v-show="!bgClass" @click="$jump('/index')">
						<img src="../../assets/imgs/logo2.png" alt="" class="imgBox" v-show="bgClass" @click="$jump('/index')">
					</el-col>
					<el-col :span="16">
						<div :class="!bgClass ? 'menuList' : 'menuListOne'">
							<el-dropdown size="mini" @command="handleCommand"  trigger="click">
								<span class="el-dropdown-link font12" :style="$route.path == '/companyIntroduction'? 'color:#2986FF' : (!bgClass ? 'color:#fff' : 'color:#000')">
									关于我们
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="企业介绍">企业介绍</el-dropdown-item>
									<el-dropdown-item command="发展历程">发展历程</el-dropdown-item>
									<el-dropdown-item command="企业文化">企业文化</el-dropdown-item>
									<el-dropdown-item command="logo释义">logo释义</el-dropdown-item>
									<el-dropdown-item command="荣誉资源">荣誉资源</el-dropdown-item>
									<el-dropdown-item command="社会责任">社会责任</el-dropdown-item>
									<el-dropdown-item command="服务承诺">服务承诺</el-dropdown-item>
									<el-dropdown-item command="党建园地">党建园地</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<el-dropdown size="mini" @command="handleCommandOne"  trigger="click">
								<span class="el-dropdown-link font12" :style="$route.path == '/InformationCenter'? 'color:#2986FF' : (!bgClass ? 'color:#fff' : 'color:#000')">
									资讯中心
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="新闻速递">新闻速递</el-dropdown-item>
									<el-dropdown-item command="行情资讯">行情资讯</el-dropdown-item>
									<el-dropdown-item command="招标公告">招标公告</el-dropdown-item>
									<el-dropdown-item command="其他公告">其他公告</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<el-dropdown size="mini" ref="subDropdown" trigger="click">
								<span class="el-dropdown-link font12" :style="($route.path == '/productCenter' || $route.path == '/yunIndex')? 'color:#2986FF' : (!bgClass ? 'color:#fff' : 'color:#000')">
									产品中心
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item  v-for="item,index in menuList" :key="index">
										<el-dropdown placement="right-start" :show-timeout="0" ref="subDropdown">
											<div @click="handleCommandThree(item)">{{item.name}} <span v-show="item.children.length > 0"><i class="el-icon-arrow-right" style="margin-left: 5px;"></i></span></div>
											<el-dropdown-menu slot="dropdown" v-if="item.children.length > 0">
												<el-dropdown-item v-for="child,indexOne in item.children" :key="indexOne" @click.native="handleCommandThree(child)">{{child.name}}</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<el-dropdown size="mini"  trigger="click">
								<span class="el-dropdown-link font12" :style="$route.path == '/technicalService'? 'color:#2986FF' : (!bgClass ? 'color:#fff' : 'color:#000')">
									技术服务
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item  v-for="item,index in menuListOne" :key="index">
										<el-dropdown placement="right-start" :show-timeout="0" ref="subDropdown">
											<div @click="handleCommandThree(item)">{{item.name}}</div>
											<el-dropdown-menu slot="dropdown" v-if="item.children.length > 0">
												<el-dropdown-item v-for="child,indexOne in item.children" :key="indexOne" @click.native="handleCommandThree(child)">{{child.name}}</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<el-dropdown size="mini" @command="handleCommandTwo"  trigger="click">
								<span class="el-dropdown-link font12" :style="($route.path == '/recruitPeople' || $route.path == '/contactInfomation' || $route.path == '/cooperation' )? 'color:#2986FF' : (!bgClass ? 'color:#fff' : 'color:#000')">
									联系我们
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="招贤纳士">招贤纳士</el-dropdown-item>
									<el-dropdown-item command="联系方式">联系方式</el-dropdown-item>
									<el-dropdown-item command="意向合作">意向合作</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<span @click="goXunjia" class="font12">招采系统</span>
						</div>
					</el-col>
					<el-col :span="3" style="text-align: right;">
						<el-button type="primary" size="small" style="margin-top: 15px;background-color:#2986FF;border-color:#2986FF;" @click="goShop">爱养牛商城</el-button>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
import {treeCodeList} from './../../request/service'
export default {
	name: 'menuNav',
	components: {

	},
	props:{
		bgClass:{
			type:Boolean,
			default:false
		}
	},
	data() {
		return {
			menuList:[],
			menuListOne:[],
		}
	},
	computed: {

	},
	methods: {
		handleCommand(val){
			if(val == '企业介绍'){
				this.$jump('/companyIntroduction?type=1')
			}else if(val == '发展历程'){
				this.$jump('/companyIntroduction?type=2')
			}else if(val == '企业文化'){
				this.$jump('/companyIntroduction?type=3')
			}else if(val == 'logo释义'){
				this.$jump('/companyIntroduction?type=4')
			}else if(val == '荣誉资源'){
				this.$jump('/companyIntroduction?type=5')
			}else if(val == '社会责任'){
				this.$jump('/socialResponsibility')
			}else if(val == '服务承诺'){
				this.$jump('/serviceCommitment')
			}else if(val == '党建园地'){
				this.$jump('/buildGarden')
			}
		},
		handleCommandOne(val){
			if(val == '新闻速递'){
				this.$jump('/InformationCenter?type=zxzx_001_001')
			}else if(val == '行情资讯'){
				this.$jump('/InformationCenter?type=zxzx_001_002')
			}else if(val == '招标公告'){
				this.$jump('/InformationCenter?type=zxzx_001_003')
			}else if(val == '其他公告'){
				this.$jump('/InformationCenter?type=zxzx_001_004')
			}
		},
		handleCommandTwo(val){
			if(val == '招贤纳士'){
				this.$jump('/recruitPeople')
			}else if(val == '联系方式'){
				this.$jump('/contactInfomation')
			}else if(val == '意向合作'){
				this.$jump('/cooperation')
			}
		},
		handleCommandThree(item){
			if(item.isRedirect == 1){  //设置了跳转
				if(item.link.indexOf('www.aiyangniu.net') !== -1 || item.link.indexOf('www.aiyangniu.cn') !== -1){  
					this.$jump({path:item.link.split("#")[1]})
				}else{
					window.open(item.link)
				}
			}
		},
		goXunjia(){
			window.open('https://zhaocai.aiyangniu.cn')
		},
		goShop(){
			window.open('https://shop.aiyangniu.cn')
		},
		getMenu(){
			treeCodeList({typeCode:'cpzx_001'}).then((res) => {
				if(res.code == 101){
					this.menuList = res.data
				}else{
					this.$Message.error(res.message);
				}
			})
		},
		getMenuOne(){
			treeCodeList({typeCode:'jsfw_001'}).then((res) => {
				if(res.code == 101){
					this.menuListOne = res.data
				}else{
					this.$Message.error(res.message);
				}
			})
		},
	},

	mounted() {
		this.getMenu()
		this.getMenuOne()
	},

	watch: {

	}
}
</script>

<style lang="less" scoped>
.menuNav{
	height: 50px;
	position: fixed;
	z-index: 99;
	top: 0;
	.menuBox{
		width: 100%;
		height: 50px;
		background-color: rgba(255, 255, 255, 0.1)
	}
	.menuBoxOne{
		width: 100%;
		height: 50px;
		position: fixed;
		top: 0;
		z-index: 99;
		border-bottom: 1px solid #eee;
		background-color: rgba(255, 255, 255,1)
	}
	.menu{
		width: 1200PX;
		height: 50px;
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin: 0 auto;
		cursor: pointer;
	}
	.imgBox{
		width: 65%;
		margin-top: 4px;
	}
	.menuList{
		line-height: 50px;
		font-size: 12px !important;
		color: #fff;
		span{
			margin: 0 18px;
		}
	}
	.menuListOne{
		line-height: 50px;
		font-size: 12px !important;
		color: #000;
		span{
			margin: 0 18px;
		}
	}
	.activeColor{
		color: rgb(41, 134, 255);
	}
}
</style>
<style scolang="less">
.menuNav{
	.font12{
		font-size: 12px;
	}
	.el-submenu__title{
		font-size: 12px !important;
	}
	.el-menu-item{
		font-size: 0.3rem !important;
	}
	.el-menu{
		background-color: transparent !important;
		color: #000;
	}
	.el-menu.el-menu--horizontal{
		border-bottom: 0px !important;
	}
	.el-menu--horizontal>.el-submenu .el-submenu__title{
		color: #000;
		height:  50px;
    	line-height:  50px;
	}
	.el-menu--horizontal>.el-menu-item{
		color: #000;
		height:  50px;
    	line-height:  50px;
	}
	.el-submenu__title i{
		color: #000;
	}
	.el-submenu__title{
		padding: 0 10px;
	}
	.el-menu--popup{
		min-width: 2.5rem !important;
	}
	.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
		color: #000;
		font-size: 12px !important;
	}
}
.el-dropdown{
	font-size: 10px !important;
}
.el-dropdown-menu__item{
	font-size: 10px !important;
	padding: 0 10px;
	line-height: 0.7rem;
}
.el-dropdown-menu{
	padding: 3px 0;
	margin: 0;
}
</style>